<fieldset *ngIf="paymentMethodSelectionList$ | async as methodList" class="mode-{{ mode }}">
  <div *ngIf="(expressCheckoutConfig$ | async) !== null" class="d-flex flex-column justify-content-start">
    <div *ngIf="isPageBuilderDesignMode(); else showExpressCheckout" class="d-flex flex-row justify-content-start">
      <svg class="m-0" width="260" height="50" viewBox="0 0 260 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="260" height="50" rx="8" fill="black" />
        <rect width="260" height="50" rx="8" stroke="black" />
        <path
          d="M114.248 19.8275C112.911 19.8275 111.833 20.636 111.137 20.636C110.407 20.636 109.43 19.8724 108.273 19.8724C106.072 19.8724 103.837 21.7029 103.837 25.1282C103.837 27.2733 104.668 29.5306 105.69 31.0018C106.555 32.2259 107.33 33.2366 108.43 33.2366C109.52 33.2366 110.003 32.5179 111.362 32.5179C112.732 32.5179 113.046 33.2142 114.248 33.2142C115.45 33.2142 116.247 32.1248 116.999 31.0467C117.83 29.8001 118.19 28.5872 118.201 28.5311C118.134 28.5086 115.843 27.5765 115.843 24.9485C115.843 22.68 117.639 21.6693 117.741 21.5906C116.561 19.8724 114.753 19.8275 114.248 19.8275ZM113.63 18.3787C114.169 17.7161 114.551 16.8177 114.551 15.908C114.551 15.7845 114.54 15.6609 114.517 15.5599C113.641 15.5936 112.563 16.1439 111.923 16.8963C111.429 17.4691 110.957 18.3787 110.957 19.2884C110.957 19.4232 110.98 19.5692 110.991 19.6141C111.047 19.6253 111.137 19.6365 111.227 19.6365C112.024 19.6365 113.035 19.0975 113.63 18.3787ZM122.615 16.8289V33.0345H125.513V27.7225H129.028C132.307 27.7225 134.598 25.5213 134.598 22.3094C134.598 19.0413 132.386 16.8289 129.152 16.8289H122.615ZM125.513 19.2547H128.388C130.477 19.2547 131.656 20.3216 131.656 22.3094C131.656 24.241 130.443 25.3192 128.377 25.3192H125.513V19.2547ZM140.035 31.0467C138.8 31.0467 137.912 30.429 137.912 29.3958C137.912 28.3963 138.642 27.8348 140.203 27.7337L142.977 27.554V28.5311C142.977 29.9573 141.719 31.0467 140.035 31.0467ZM139.215 33.2366C140.821 33.2366 142.169 32.5403 142.854 31.3499H143.045V33.0345H145.729V24.6453C145.729 22.0399 143.954 20.5013 140.799 20.5013C137.879 20.5013 135.846 21.8826 135.621 24.0501H138.249C138.508 23.2191 139.384 22.7698 140.664 22.7698C142.169 22.7698 142.977 23.4437 142.977 24.6453V25.6785L139.81 25.8694C136.823 26.0491 135.15 27.3294 135.15 29.553C135.15 31.7991 136.845 33.2366 139.215 33.2366ZM148.829 37.493C151.581 37.493 152.895 36.4822 153.939 33.4276L158.375 20.7484H155.433L152.569 30.3392H152.378L149.503 20.7484H146.448L150.84 33.0906L150.694 33.6297C150.334 34.764 149.672 35.2132 148.492 35.2132C148.301 35.2132 147.886 35.202 147.729 35.1683V37.4481C147.908 37.4818 148.661 37.493 148.829 37.493Z"
          fill="white"
        />
      </svg>
      <svg width="260" height="50" viewBox="0 0 260 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="260" height="50" rx="4" fill="black" />
        <path
          d="M127.951 24.6725V31.7485H125.69V14.2748H131.683C133.202 14.2748 134.498 14.7778 135.557 15.7836C136.641 16.7895 137.182 18.0175 137.182 19.4678C137.182 20.9532 136.641 22.1813 135.557 23.1754C134.509 24.1696 133.214 24.6608 131.683 24.6608H127.951V24.6725ZM127.951 16.4269V22.5204H131.731C132.625 22.5204 133.379 22.2164 133.968 21.6199C134.568 21.0234 134.874 20.2982 134.874 19.4795C134.874 18.6725 134.568 17.9591 133.968 17.3626C133.379 16.7427 132.637 16.4386 131.731 16.4386H127.951V16.4269Z"
          fill="white"
        />
        <path
          d="M143.093 19.3976C144.766 19.3976 146.084 19.8421 147.05 20.7309C148.015 21.6198 148.498 22.8362 148.498 24.3801V31.7485H146.343V30.0877H146.249C145.319 31.4561 144.071 32.1344 142.517 32.1344C141.186 32.1344 140.079 31.7485 139.184 30.9649C138.289 30.1812 137.842 29.2105 137.842 28.0409C137.842 26.8011 138.313 25.8187 139.255 25.0935C140.197 24.3567 141.457 23.9941 143.023 23.9941C144.365 23.9941 145.472 24.2397 146.332 24.7309V24.2163C146.332 23.4327 146.025 22.7777 145.401 22.228C144.777 21.6783 144.047 21.4093 143.211 21.4093C141.951 21.4093 140.95 21.9356 140.22 22.9999L138.23 21.7602C139.325 20.1812 140.95 19.3976 143.093 19.3976ZM140.173 28.076C140.173 28.6608 140.421 29.152 140.927 29.538C141.421 29.9239 142.01 30.1227 142.681 30.1227C143.635 30.1227 144.483 29.7719 145.225 29.0701C145.967 28.3684 146.343 27.5497 146.343 26.6023C145.637 26.0526 144.66 25.7719 143.4 25.7719C142.481 25.7719 141.716 25.9941 141.103 26.4268C140.479 26.883 140.173 27.4327 140.173 28.076Z"
          fill="white"
        />
        <path
          d="M160.791 19.7836L153.255 37H150.924L153.726 30.9766L148.757 19.7836H151.218L154.798 28.3684H154.845L158.33 19.7836H160.791Z"
          fill="white"
        />
        <path
          d="M118.958 23.2456C118.958 22.5134 118.892 21.8128 118.77 21.1391H109.293V24.9988L114.751 24.9999C114.53 26.2842 113.817 27.3789 112.726 28.1087V30.6128H115.975C117.872 28.8689 118.958 26.2912 118.958 23.2456Z"
          fill="#4285F4"
        />
        <path
          d="M112.727 28.1088C111.823 28.7146 110.658 29.069 109.296 29.069C106.664 29.069 104.431 27.3076 103.632 24.9333H100.281V27.5158C101.941 30.7883 105.353 33.0339 109.296 33.0339C112.021 33.0339 114.31 32.1438 115.976 30.6117L112.727 28.1088Z"
          fill="#34A853"
        />
        <path
          d="M103.316 23.0176C103.316 22.3509 103.428 21.7065 103.632 21.1006V18.5182H100.281C99.5942 19.8714 99.208 21.3989 99.208 23.0176C99.208 24.6363 99.5954 26.1638 100.281 27.517L103.632 24.9345C103.428 24.3287 103.316 23.6842 103.316 23.0176Z"
          fill="#FABB05"
        />
        <path
          d="M109.296 16.9649C110.783 16.9649 112.115 17.4737 113.166 18.4679L116.045 15.6106C114.297 13.993 112.017 13 109.296 13C105.355 13 101.941 15.2456 100.281 18.5182L103.632 21.1006C104.431 18.7263 106.664 16.9649 109.296 16.9649Z"
          fill="#E94235"
        />
      </svg>
    </div>

    <ng-template #showExpressCheckout>
      <orderform-payment-express-checkout
        *ngIf="!(isPlainModeEnabled() && isAccessibilityToggleEnabled())"
        class="w-lg-50"
      >
      </orderform-payment-express-checkout>
    </ng-template>

    <div class="or-divider">
      <span *ngIf="!(isPlainModeEnabled() && isAccessibilityToggleEnabled())" i18n="@@payment_method.or"> ODER </span>
    </div>
  </div>

  <legend i18n="@@payment_method.title.payment_options" *ngIf="methodList.length"> Zahlungsmöglichkeiten </legend>

  <ng-container *ngIf="selectedPaymentMethod$ | async as selectedMethod" [formGroup]="formGroup">
    <ng-template #content>
      <div
        id="paymentMethodInput"
        class="payment-method-input"
        *ngIf="selectedMethod"
        [ngSwitch]="selectedMethod.renderer_type"
      >
        <ng-container *ngIf="selectedMethod.disabled; else showPaymentMethod">
          <div class="text-center alert alert-danger" [innerHTML]="selectedMethod.disabled_message"></div>
        </ng-container>
        <ng-container *ngIf="selectedMethod.status">
          <div class="text-center alert alert-danger">
            <div [class.text-bold]="selectedMethod.status.details" [innerHTML]="selectedMethod.status.message"></div>
            <div *ngIf="selectedMethod.status.details" [innerHTML]="selectedMethod.status.details"></div>
          </div>
        </ng-container>
        <ng-template #showPaymentMethod>
          <div class="DIE" *ngIf="selectedMethod.pay_method !== 'alias'">
            <p
              *ngIf="selectedMethod.label_data && selectedMethod.label_data.hint_text"
              [innerHTML]="selectedMethod.label_data.hint_text | sanitize : 'HTML'"
            ></p>

            <orderform-payment-method-elv
              *ngSwitchCase="'ELV'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:elv'"
            ></orderform-payment-method-elv>
            <orderform-payment-method-unzer
              *ngSwitchCase="'unzer'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:unzer'"
            ></orderform-payment-method-unzer>
            <orderform-payment-method-umsbanking
              *ngSwitchCase="'umsbanking'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:umsbanking'"
            ></orderform-payment-method-umsbanking>
            <orderform-payment-method-stripe
              *ngSwitchCase="'stripe'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [styles]="{
                textColor: textColor,
                inputFieldColor: inputFieldColor,
                placeholderColor: placeholderColor,
                fontSize: fontSize
              }"
              [attr.data-e2e]="'form:stripe'"
            ></orderform-payment-method-stripe>

            <orderform-payment-method-stripe-v2
              *ngSwitchCase="'stripe_v2'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [styles]="{
                textColor: textColor,
                inputFieldColor: inputFieldColor,
                placeholderColor: placeholderColor,
                fontSize: fontSize
              }"
              [attr.data-e2e]="'form:stripe'"
            ></orderform-payment-method-stripe-v2>

            <orderform-payment-method-stripe-sepa-v2
              *ngSwitchCase="'stripe_sepa_v2'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [styles]="{
                textColor: textColor,
                inputFieldColor: inputFieldColor,
                placeholderColor: placeholderColor,
                fontSize: fontSize
              }"
              [attr.data-e2e]="'form:stripe-sepa-v2'"
            ></orderform-payment-method-stripe-sepa-v2>

            <orderform-payment-method-heidelpay-cc
              *ngSwitchCase="'heidelpay_cc'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:heidelpay_cc'"
            ></orderform-payment-method-heidelpay-cc>
            <orderform-payment-method-braintree
              *ngSwitchCase="'braintree'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:braintree'"
              (notAvailable)="addProviderToInvisibleList(selectedMethod.payment_provider_id)"
              [styles]="{
                textColor: textColor,
                inputFieldColor: inputFieldColor,
                placeholderColor: placeholderColor,
                fontSize: fontSize
              }"
            ></orderform-payment-method-braintree>
            <orderform-payment-method-klarna
              *ngSwitchCase="'klarna'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:klarna'"
              (notAvailable)="addProviderToInvisibleList(selectedMethod.payment_provider_id)"
            ></orderform-payment-method-klarna>
            <orderform-payment-method-klarna
              *ngSwitchCase="'klarna_billieio'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:klarna'"
              (notAvailable)="addProviderToInvisibleList(selectedMethod.payment_provider_id)"
            ></orderform-payment-method-klarna>
            <orderform-payment-method-venmo
              *ngSwitchCase="'venmo'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:venmo'"
              (notAvailable)="addProviderToInvisibleList(selectedMethod.payment_provider_id)"
            ></orderform-payment-method-venmo>
            <orderform-payment-method-primer
              *ngSwitchCase="'primer'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:primer'"
            ></orderform-payment-method-primer>
            <orderform-payment-method-primer-paypal
              *ngSwitchCase="'primer_paypal'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:primer'"
            ></orderform-payment-method-primer-paypal>
            <orderform-payment-method-primer-google-apple-pay
              *ngSwitchCase="'primer_apple_google_pay'"
              formControlName="providerData"
              [config]="selectedMethod.config_data"
              [attr.data-e2e]="'form:primer'"
              (paymentMethodTypeDetected)="onPrimerGoogleAppleTypeDetected($event)"
            ></orderform-payment-method-primer-google-apple-pay>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <div
      class="payment-method-selection DIE"
      [ngClass]="{
        disabled: selectedMethod.pay_method === 'void' || selectedMethod.pay_method === 'alias',
        'flex-column': isPlainModeEnabled() && isAccessibilityToggleEnabled(),
      }"
      [orderformBreakpoint]="breakpointConfiguration$ | async"
      [attr.data-e2e]="'payment_provider_id:' + selectedMethod.payment_provider_id"
    >
      <div
        *ngIf="
          !isPageBuilderDesignMode() &&
          isPlainModeEnabled() &&
          isAccessibilityToggleEnabled() &&
          isExpressChekoutAvailable()
        "
        class="express-checkout-container justify-space-around"
      >
        <orderform-payment-express-checkout class="w-50 d-flex"></orderform-payment-express-checkout>
      </div>

      <ng-container *ngFor="let method of methodList; trackBy: trackByRendererType">
        <div
          class="payment-item"
          [ngClass]="{
            active: selectedMethod.pay_method === method.pay_method,
            'not-available': method.disabled,
            'two-switch': methodList.length <= 2,
            'full-width': isPlainModeEnabled() && isAccessibilityToggleEnabled()
          }"
        >
          <div class="bg-container"></div>
          <label
            [ngClass]="{
              'justify-space-around': isPlainModeEnabled() && isAccessibilityToggleEnabled(),
            }"
            [for]="method.pay_method"
            [attr.data-e2e]="'order:payment_method:' + method.pay_method"
          >
            <input
              type="radio"
              formControlName="providerId"
              [id]="method.pay_method"
              [value]="method.payment_provider_id"
            />
            <div class="icon-container">
              <span
                class="normal"
                [ngClass]="{
                  'has-large': !!method.icon_data.large,
                  'has-small': !!method.icon_data.small
                }"
              >
                <img
                  [alt]="method.icon_data.alt"
                  [src]="
                    method.pay_method === 'apple_google_pay' && detectedGoogleAppleMethodType === 'APPLE_PAY'
                      ? method.icon_data.url[paymentIconsTheme].replace('_google', '_apple')
                      : method.icon_data.url[paymentIconsTheme]
                  "
                  [height]="method.icon_data.height"
                  [width]="method.icon_data.width"
                /><br />
                <span class="text" *ngIf="method.icon_data.text">{{ method.icon_data.text }}</span>
              </span>

              <span class="large" *ngIf="!!method.icon_data.large">
                <img
                  [alt]="method.icon_data.alt"
                  [src]="
                    method.pay_method === 'apple_google_pay' && detectedGoogleAppleMethodType === 'APPLE_PAY'
                      ? method.icon_data.large.url[paymentIconsTheme].replace('_google', '_apple')
                      : method.icon_data.large.url[paymentIconsTheme]
                  "
                  [height]="method.icon_data.large.height"
                  [width]="method.icon_data.large.width"
                />
                <span class="text" *ngIf="method.icon_data.large.text">{{ method.icon_data.large.text }}</span>
              </span>

              <span class="small" *ngIf="!!method.icon_data.small">
                <img
                  *ngIf="method.pay_method !== 'creditcard'"
                  [alt]="method.icon_data.alt"
                  [src]="
                    method.pay_method === 'apple_google_pay' && detectedGoogleAppleMethodType === 'APPLE_PAY'
                      ? method.icon_data.small.url[paymentIconsTheme].replace('_google', '_apple')
                      : method.icon_data.small.url[paymentIconsTheme]
                  "
                  [height]="method.icon_data.small.height"
                  [width]="method.icon_data.small.width"
                />
                <img
                  *ngIf="method.pay_method === 'creditcard'"
                  [alt]="method.icon_data.alt"
                  [src]="method.icon_data.small.url[paymentIconsTheme]"
                />
                <br />
                <span
                  class="text"
                  *ngIf="
                    method.icon_data.small.text &&
                    method.pay_method !== 'creditcard' &&
                    method.pay_method !== 'apple_google_pay'
                  "
                  >{{ method.icon_data.small.text }}</span
                >
              </span>
            </div>
            <span
              class="payment-description"
              [ngClass]="{
                'display-inline': isPlainModeEnabled() && isAccessibilityToggleEnabled(),
              }"
              >{{ method.icon_data.alt }}</span
            >
          </label>
        </div>

        <ng-container *ngIf="mode === 'vertical' && selectedMethod.pay_method === method.pay_method">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="mode === 'horizontal'">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>

    <p
      *ngIf="showCostsHint === 'true' && (resellerId$ | async) !== SiteOwners.DIGISTORE24_INC"
      class="payment-method-additional-info"
      i18n="@@orderform.payment-method-additional-info"
    >
      Keine Zusatzkosten durch diese Bezahlmethode
    </p>
  </ng-container>
</fieldset>
